import { __decorate } from "tslib";
import { create } from '@patsnap/tahiti-core/utils/deferred';
import { provide } from '@/inversify.config';
export const AuthServiceSymbol = Symbol.for('AuthService');
let AuthService = class AuthService {
    constructor() {
        this.authDeferred = create();
    }
};
AuthService = __decorate([
    provide(AuthServiceSymbol)
], AuthService);
export { AuthService };
